setTimeout(function(){
  var selector = document.querySelector('.limespot-recommendation-box-carousel-container');
  if(selector){
    selector.classList.add('page-width');
  };
},8000);  

function getHeaderHeight() {
  const header = document.querySelector('.itg-header'); 
  if (header) {
    const height = header.offsetHeight;
    document.querySelector('.collection-filter')?.style.setProperty('top', `${height}px`);
    document.querySelector('[data-sticky-sidebar]')?.style.setProperty('top', `${height}px`);
    return height;
  }
}

window.addEventListener('resize', getHeaderHeight);
window.addEventListener('DOMContentLoaded', getHeaderHeight);

// custom js Ap
if (window.location.pathname.includes('pages/shop-solids')) {
  window.location.href = '/';
}
